import React, { useEffect } from 'react'
import HeaderTop from '../Components/Header/HeaderTop';
import HeaderMiddle from '../Components/Header/HeaderMiddle';
import HeaderBottom from '../Components/Header/HeaderBottom';
import MobileNavigation from '../Components/Header/MobileNavigation';


const Header = () => {
    return (
        <>
            <header className="header-area header-style-1 header-height-2">
                <div className="mobile-promotion">
                    <span><strong>Crafted by Earth. Chosen by You.</strong></span>
                </div>

                <div className="header-top header-top-ptb-1 d-none d-lg-block">
                    <HeaderTop />
                </div>
                <div className="header-middle header-middle-ptb-1 d-none d-lg-block">
                    <HeaderMiddle />
                </div>
                <div className="header-bottom header-bottom-bg-color sticky-bar">
                    <HeaderBottom />
                </div>

                <MobileNavigation />
            </header>
        </>
    )
}

export default Header